import { PlaybackType } from '../../../core/player/playout-data';
export var NielsenDefaultEnabledPlaybackTypes = [
    PlaybackType.Live,
    PlaybackType.VOD,
    PlaybackType.Advert,
    PlaybackType.SingleLiveEvent,
    PlaybackType.Preview,
    PlaybackType.Clip,
    PlaybackType.FER
];

//# sourceMappingURL=nielsen-types.js.map